import React, { useState } from "react";
import {
  Grid,
  Box,
  Typography,
  IconButton,
  Paper,
  Tooltip,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";
import FolderIcon from "@mui/icons-material/Folder";
import MoreVertIcon from "@mui/icons-material/MoreVert";

const FolderGrid = ({ folders, onOpen, onDelete, onRename, currentPath }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [renameDialogOpen, setRenameDialogOpen] = useState(false);
  const [newFolderName, setNewFolderName] = useState("");

  const openMenu = (e, folder) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
    setSelectedFolder(folder);
  };

  const closeMenu = () => {
    setAnchorEl(null);
    setSelectedFolder(null);
  };

  const startRename = () => {
    setNewFolderName(selectedFolder);
    setRenameDialogOpen(true);
    closeMenu();
  };

  const handleRename = () => {
    if (newFolderName.trim() && selectedFolder) {
      onRename(selectedFolder, newFolderName.trim());
    }
    setRenameDialogOpen(false);
    setSelectedFolder(null);
    setNewFolderName("");
  };

  const handleDelete = () => {
    onDelete(selectedFolder);
    closeMenu();
  };

  return (
    <>
      <Grid container spacing={3} mt={2}>
        {folders.map((folder) => (
          <Grid item key={folder} xs={12} sm={6} md={4} lg={3} xl={2}>
            <Paper
              elevation={3}
              sx={{
                p: 2,
                borderRadius: 3,
                transition: "0.3s",
                cursor: "pointer",
                "&:hover": {
                  boxShadow: 6,
                  transform: "translateY(-2px)",
                },
                position: "relative",
              }}
              onClick={() => onOpen(`${currentPath}/${folder}`)}
            >
              {/* 3-Dot Menu Button */}
              <Tooltip title="Options">
                <IconButton
                  size="small"
                  sx={{ position: "absolute", top: 8, right: 8, zIndex: 1 }}
                  onClick={(e) => openMenu(e, folder)}
                >
                  <MoreVertIcon fontSize="small" />
                </IconButton>
              </Tooltip>

              {/* Folder Icon */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  mb: 1,
                }}
              >
                <FolderIcon sx={{ fontSize: 60, color: "#facc15" }} />
              </Box>

              {/* Folder Name */}
              <Typography
                variant="subtitle2"
                align="center"
                noWrap
                sx={{ fontWeight: 500 }}
              >
                {folder}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>

      {/* Dropdown Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={closeMenu}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem onClick={startRename}>Rename</MenuItem>
        <MenuItem onClick={handleDelete}>Delete</MenuItem>
      </Menu>

      {/* Rename Dialog */}
      <Dialog open={renameDialogOpen} onClose={() => setRenameDialogOpen(false)}>
        <DialogTitle>Rename Folder</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Folder Name"
            type="text"
            fullWidth
            variant="outlined"
            value={newFolderName}
            onChange={(e) => setNewFolderName(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setRenameDialogOpen(false)}>Cancel</Button>
          <Button onClick={handleRename} variant="contained">
            Rename
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default FolderGrid;
